/* unplugin-vue-components disabled */import { render } from "./DeviceDetail.vue?vue&type=template&id=2c16325e&scoped=true&ts=true"
import script from "./DeviceDetail.vue?vue&type=script&lang=ts"
export * from "./DeviceDetail.vue?vue&type=script&lang=ts"

import "./DeviceDetail.vue?vue&type=style&index=0&id=2c16325e&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c16325e"]])

export default __exports__